import { gql } from '@apollo/client';

export const EDIT_EVENT = gql`
  mutation($eventUuid: String!, $data: editEventInput!) {
    editEvent(eventUuid: $eventUuid, data: $data) {
      uuid
    }
  }
`;

